export enum ResultadoPruebaLab {
    Pendiente = 0,
    Aprobado = 1,
    Rechazado = 2
}